import { Box, useTheme } from '@mui/material';
import { useAppSelector } from 'hooks/redux.hooks';
import { getSubMenu } from 'state/reducers/content.reducers';
import { MenuListItem } from 'components/MenuListItem';
import { AuthorizationComponent } from 'components/AuthorizationComponent';
import { IMenuItemChild } from 'constants/ui.constants';

interface IProps {
	handleClick: any;
	open: boolean;
	styleObj?: any;
}

export const SubMenu = ({ handleClick, open, styleObj }: IProps) => {
	const subMenu = useAppSelector(getSubMenu);
	const theme = useTheme();

	return (
		<>
			{subMenu?.length > 0 && (
				<Box sx={{ background: theme.palette.root.basicDeeoGreen, ...styleObj }}>
					{subMenu?.map((page: IMenuItemChild, index: number) => (
						<AuthorizationComponent permissions={page.permissions} key={index}>
							<MenuListItem
								key={index}
								name={page.displayTitle}
								handleClick={() => handleClick(subMenu[index])}
								open={open}
								styleObj={{ paddingLeft: '17%' }}
								icon={page.icon || ''}
							/>
						</AuthorizationComponent>
					))}
				</Box>
			)}
		</>
	);
};
